<template>
  <div class="panel">
    <el-col :span="12">
      <span class="version-label">
        最新版本: <span onclick="{window.open('https://github.com/karldoenitz/Tigo/releases', '_blank')}" class="version">2.0.0</span>
      </span>
    </el-col>
    <el-col :span="12">
      <span class="language-label">
      <el-dropdown>
      <span class="el-dropdown-link">
        语言<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>中文</el-dropdown-item>
          <el-dropdown-item><span onclick="{window.open('/Tigo-EN', '_self')}"><div>ENGLISH</div></span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </span>
    </el-col>
  </div>
</template>

<script>
  export default {
    name: "DocumentationLanguage"
  }
</script>

<style scoped>
  .panel {
    height: 35px;
    width: 100%;
    background-color: #f2f2f3;
    padding-top: 10px;
  }

  .version {
    color: rgb(64, 158, 255);
  }

  .version-label {
    float: right;
    padding-right: 290px;
  }

  .language-label {
    float: left;
    padding-left: 354px;
  }

  @media screen and (max-width: 820px) {
    .version-label {
      display: none;
    }
    .language-label {
      float: left;
      padding-left: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ch/DocumentationLanguage.vue